import React from 'react';
import { socialActions_labels_share, socialActions_actions_retweet, socialActions_actions_quoteTweet } from '@paraglide/messages';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Repeat2 } from 'lucide-react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { ActionGroup, CountSpan, RetweetOptionsPopup } from '../SocialActions.styles';
import { formatNumber, getButtonSize } from '../utils';
export var RetweetButton = function(param) {
    var retweeted = param.retweeted, retweetsCount = param.retweetsCount, showRetweetOptions = param.showRetweetOptions, retweetOptionsRef = param.retweetOptionsRef, onRetweetClick = param.onRetweetClick, onRetweet = param.onRetweet, onQuoteTweet = param.onQuoteTweet, size = param.size, showCounts = param.showCounts, labels = param.labels;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionGroup, null, /*#__PURE__*/ React.createElement(Button, {
        iconOnly: true,
        size: getButtonSize(size),
        variant: "ghost",
        icon: /*#__PURE__*/ React.createElement(Repeat2, {
            className: retweeted ? "fill-current" : "",
            strokeWidth: retweeted ? 2.5 : 2,
            fill: retweeted ? "currentColor" : "none"
        }),
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
            onRetweetClick(e);
        },
        label: labels.share || socialActions_labels_share(),
        className: "border-0 ".concat(retweeted ? "text-green-500 dark:text-green-400" : "text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:text-green-400"),
        animation: "none"
    }), showCounts && retweetsCount > 0 && /*#__PURE__*/ React.createElement(CountSpan, {
        $active: retweeted,
        color: "green"
    }, formatNumber(retweetsCount))), showRetweetOptions && /*#__PURE__*/ React.createElement(RetweetOptionsPopup, {
        ref: retweetOptionsRef,
        className: "relative z-50",
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: getButtonSize(size),
        leftIcon: /*#__PURE__*/ React.createElement(Repeat2, {
            size: 16
        }),
        className: "border-0 flex items-center px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 w-full text-left",
        onClick: onRetweet
    }, socialActions_actions_retweet()), /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: getButtonSize(size),
        leftIcon: /*#__PURE__*/ React.createElement(MessageCircle, {
            size: 16
        }),
        className: "border-0 flex items-center px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 w-full text-left border-t border-gray-200 dark:border-gray-700",
        onClick: onQuoteTweet
    }, socialActions_actions_quoteTweet())));
};
